/* eslint react/jsx-filename-extension: 0 */
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import './App.css';

import Login from './components/Login';
import PasswordForget from './components/PasswordForget';
import Home from './components/Home';
import Account from './components/Account';
import WebProperties from './components/WebProperties';
import NotFound from './components/NotFound';

import routes from './routes.json';
import withAuthentication from './withAuthentication';

const reload = () => window.location.reload();

const App = () => (
  <Router>
    <Switch>
      <Route exact path={routes.login} component={Login} />
      <Route
        exact
        path={routes.passwordForget}
        component={() => <PasswordForget />}
      />
      <Route exact path={routes.home} component={Home} />
      <Route exact path={routes.account} component={Account} />
      <Route exact path={routes.allWebProperties} component={WebProperties} />
      <Route path="/pages" onEnter={reload} />
      <Route path="*" component={NotFound} />
    </Switch>
  </Router>
);

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/App.js